import { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { EASE } from "./Reveal";

export default function Preloader({ onDone }) {
  const doneRef = useRef(false);

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const t = setTimeout(
      () => {
        if (!doneRef.current) {
          doneRef.current = true;
          onDone?.();
        }
      },
      reduced ? 300 : 1500
    );
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <motion.div
      data-testid="preloader"
      exit={{ y: "-100%" }}
      transition={{ duration: 0.85, ease: EASE }}
      className="fixed inset-0 z-[200] flex flex-col items-center justify-center overflow-hidden bg-accent"
    >
      <motion.h1
        className="select-none font-serif text-[17vw] uppercase leading-none tracking-tight text-white sm:text-[13vw] lg:text-[11rem]"
        initial={{ y: 90, scale: 0.65, opacity: 0, filter: "blur(14px)" }}
        animate={{
          y: [90, 0, 0, -140],
          scale: [0.65, 1.06, 1, 1],
          opacity: [0, 1, 1, 0],
          filter: ["blur(14px)", "blur(0px)", "blur(0px)", "blur(6px)"],
        }}
        transition={{ duration: 1.7, times: [0, 0.42, 0.66, 1], ease: EASE }}
      >
        STROVYN.
      </motion.h1>

      <motion.div
        initial={{ scaleX: 0, opacity: 0 }}
        animate={{ scaleX: 1, opacity: 1 }}
        transition={{ delay: 0.75, duration: 0.6, ease: EASE }}
        className="mt-6 h-px w-56 bg-white/70 sm:w-72"
        aria-hidden="true"
      />
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.95, duration: 0.5 }}
        className="mt-4 font-mono text-[10px] uppercase tracking-[0.35em] text-white/80"
      >
        A new standard in innovation
      </motion.p>

      <div className="absolute bottom-0 left-0 h-1 w-full bg-white/90" aria-hidden="true" />
    </motion.div>
  );
}
